import createReactComponent from '../createReactComponent';
export default createReactComponent('current-location', 'IconCurrentLocation', [
  ['path', { d: 'M12 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0', key: 'svg-0' }],
  ['path', { d: 'M12 12m-8 0a8 8 0 1 0 16 0a8 8 0 1 0 -16 0', key: 'svg-1' }],
  ['path', { d: 'M12 2l0 2', key: 'svg-2' }],
  ['path', { d: 'M12 20l0 2', key: 'svg-3' }],
  ['path', { d: 'M20 12l2 0', key: 'svg-4' }],
  ['path', { d: 'M2 12l2 0', key: 'svg-5' }],
]);
